import React from 'react';

const InfoCt0 = props => {
  const names = props.data.map((name, index) => (
    <div key={encodeURIComponent(name[0])} className="name-wrap">
      <h4>{name[0]}</h4>
      <h5>{name[1]}</h5>
      {index === props.data.length - 1 && (
        <a
          href="http://www.zdarbuh.cz"
          target="_blank"
          rel="noopener noreferrer"
        >
          (zdarbuh.cz)
        </a>
      )}
    </div>
  ));

  return (
    <div id="info-ct-0" className="info-block">
      {names}
    </div>
  );
};

export default InfoCt0;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/ProjectInfo/InfoCt0/InfoCt0.js